import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';
import { Card } from '../UI/card';
import LandingShowcaseSection from './LandingShowcaseSection';
import LandingWorldRiskMap from './LandingWorldRiskMap';
import LandingGlobalSentimentLegend from './LandingGlobalSentimentLegend';
import { LANDING_GLOBAL_ALERTS, getAlertBorderClass } from './landingDemoData';

function LandingAlertFeed() {
  const { t } = useLocale();

  return (
    <Card className={`${themeClasses.landing.showcaseCard} h-full`}>
      <h3 className="mb-4 text-lg font-semibold tracking-tight text-text-primary">
        {t('landingGlobalAlertsTitle')}
      </h3>
      <div className="flex flex-col gap-3">
        {LANDING_GLOBAL_ALERTS.map((alert) => (
          <article
            key={alert.id}
            className={`rounded-md border border-border-light border-l-4 bg-background-secondary p-4 ${getAlertBorderClass(alert.severity)}`}
          >
            <p className="text-sm font-semibold text-text-primary">{t(alert.titleKey)}</p>
            <p className="mt-1 text-xs leading-relaxed text-text-secondary">{t(alert.descKey)}</p>
          </article>
        ))}
      </div>
    </Card>
  );
}

export default function LandingGlobalRiskShowcase() {
  const { t } = useLocale();

  return (
    <LandingShowcaseSection
      eyebrowKey="landingGlobalEyebrow"
      titleKey="landingGlobalTitle"
      subtitleKey="landingGlobalSubtitle"
    >
      <div className={themeClasses.landing.showcaseGrid}>
        <div className={`${themeClasses.landing.showcaseMapCol} h-[400px]`}>
          <Card className={`${themeClasses.landing.showcaseCard} h-full min-h-0`}>
            <h3 className="mb-4 shrink-0 text-lg font-semibold tracking-tight text-text-primary">
              {t('globalRiskDistribution')}
            </h3>
            <div className="relative min-h-0 flex-1 overflow-hidden">
              <LandingWorldRiskMap className="h-full" />
            </div>
            <LandingGlobalSentimentLegend />
          </Card>
        </div>
        <div className={`${themeClasses.landing.showcaseSideCol} h-[400px]`}>
          <LandingAlertFeed />
        </div>
      </div>
    </LandingShowcaseSection>
  );
}
